export enum InputTypes {
  BASIC_COLOR = 'Basic Color',
  FILTER = 'Filter',
}
